
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 18 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FECB00","d":"M0 0h18v6H0z"}}),_c('path',{attrs:{"fill":"#EA2839","d":"M0 6h18v6H0z"}}),_c('path',{attrs:{"fill":"#34B233","d":"M0 4h18v4H0z"}}),_c('g',{attrs:{"transform":"translate(9 6.422) scale(4.422)"}},[_c('path',{attrs:{"id":"a","fill":"#FFF","d":"M-.325 0L0-1l.325 1z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(-144)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(144)"}})])])
          )
        }
      }
    